<img class="icon" [src]="categoryIcon()" />
<div class="text-container">
  <div class="count">{{ resourcesAmount | number }}</div>
  <div class="category">
    {{ pluralizedCategoryDisplayName }}
  </div>
</div>
